import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { OverlayTrigger, Icon } from "components/common";
import { Row, Col } from "common/components/layout-styles";
import User from "security-app/components/Assets/AssetModals/AssetDetailsDrawer/UserData";
import Machine from "security-app/components/Assets/AssetModals/AssetDetailsDrawer/MachineData";
const DetailsContainer = styled(Col)`
  max-height: 600px;
  overflow: auto;
`;
const componentByType = {
  machine: (machine) => /* @__PURE__ */ React.createElement(Machine, { machineAsset: machine }),
  user: (user) => /* @__PURE__ */ React.createElement(User, { userAsset: user })
};
function OverlayTitle({ asset, assetDetailsActions: AssetDetailActions = void 0 }) {
  return /* @__PURE__ */ React.createElement(Row, { $justify: "space-between" }, /* @__PURE__ */ React.createElement("strong", null, asset.name), AssetDetailActions && /* @__PURE__ */ React.createElement(AssetDetailActions, { assetId: asset.id }));
}
function AssetDetailsOverlay({ asset, assetDetailsActions = void 0 }) {
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "right",
      overlay: /* @__PURE__ */ React.createElement(DetailsContainer, { $gap: "lg" }, componentByType[asset.details.type](asset)),
      title: /* @__PURE__ */ React.createElement(OverlayTitle, { asset, assetDetailsActions }),
      width: 600
    },
    /* @__PURE__ */ React.createElement(Row, { $gap: "xxs", $align: "center" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link" }, /* @__PURE__ */ React.createElement("strong", null, asset.name)), /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right", size: "sm" }))
  );
}
export default AssetDetailsOverlay;
